/**
 * Hand a file to the iPhone share sheet (email, WhatsApp, Files) when the browser supports
 * sharing files; otherwise download it. Returns what happened, so the screen can say so.
 */
export type ShareOutcome = "shared" | "downloaded" | "cancelled";

export async function shareFile(fileName: string, content: string | Blob, type = "text/csv"): Promise<ShareOutcome> {
  const blob = typeof content === "string" ? new Blob([content], { type }) : content;
  const file = new File([blob], fileName, { type });
  if (typeof navigator.canShare === "function" && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: fileName });
      return "shared";
    } catch (error) {
      if ((error as { name?: string }).name === "AbortError") return "cancelled";
      // Share failed for another reason: fall through to a download.
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
  return "downloaded";
}
